<script lang="ts">
    import { onMount } from "svelte";
    import { fade, blur, fly, slide, scale } from "svelte/transition";
    import {
        getCommonDateFormat,
        getShortCombinatedTimeFormat,
    } from "../script/common";
    import { onDestroy } from "svelte";
    import BatchCreator from "./BatchCreator.svelte";

    let newSesionInProgres = false;
    let sessionUserSelection = null;
    /* $: if (sessionUserSelection) {
        selectSession(sessionUserSelection);
    } */

    let exampleSessoinDEV = {
        id: 123123123,
        session: {
            hum: 40,
            usedControlProbeID: 0,
            usedOvenID: 1,
            timeOfOrder: new Date(),
            clientInfo: {
                name: "ex2",
                clientID: 3,
                contatInfo: {
                    email: "x@y.tech",
                    phone: "333 555 999",
                },
            },
            probeList: {
                0: {
                    name: "probe 0",
                },
                1: {
                    name: "probe 1",
                },
                2: {
                    name: "unmeasured probe",
                },
            },
            mesurmentList: [
                {
                    timestamp: new Date(),
                    targetValue: 10,
                    controlValue: 10.345,
                    valList: {
                        0: {
                            value: 9.85,
                        },
                        1: {
                            value: 10.05,
                        },
                    },
                },
                {
                    timestamp: new Date(),
                    targetValue: 20,
                    controlValue: 20.345,
                    valList: {
                        0: {
                            value: 19.85,
                        },
                        1: {
                            value: 20.05,
                        },
                    },
                },
            ],
        },
    };
    let curentSesionRaw = exampleSessoinDEV;
    let avalibleSesions;
    let avalibleSesionsDisplayedToSelect;
    let curentSesion = null;
    $: if (avalibleSesions) {
        avalibleSesionsDisplayedToSelect = avalibleSesions.map((session) => {
            return {
                name: session.id,
                value: session,
            };
        });
    }
    avalibleSesions = [curentSesionRaw];
    /* $: if (curentSesionRaw) {
        curentSesion = prepareSession(curentSesionRaw);
    } */

    function prepareSession(session) {
        const newSessoin = JSON.parse(JSON.stringify(session)); // deep copy
        console.log(newSessoin, newSessoin.session.timeOfOrder);
        // time
        newSessoin.session.timeOfOrder = getCommonDateFormat(
            session.session.timeOfOrder
        );

        // probeList
        newSessoin.session.probeList = Object.keys(
            session.session.probeList
        ).map((key) => {
            return {
                id: key,
                label: `Teploměr ${key}`,
                name: session.session.probeList[key].name,
            };
        });
        newSessoin.session.mesurmentList = session.session.mesurmentList.map(
            (mesurment) => {
                // console.log(newSessoin.session, session.session)
                return {
                    timestamp: getShortCombinatedTimeFormat(
                        mesurment.timestamp
                    ),
                    targetValue: mesurment.targetValue,
                    controlValue: mesurment.controlValue,
                    valList: newSessoin.session.probeList.map((probe) => {
                        if (!mesurment.valList[probe.id]) {
                            return {
                                label: probe.label,
                                value: "-",
                            };
                        }
                        return {
                            label: probe.label,
                            value: mesurment.valList[probe.id].value,
                        };
                    }),
                };
            }
        );

        return newSessoin;
    }
    function selectSession(session) {
        if (session) {
            curentSesionRaw = session;
            curentSesion = prepareSession(curentSesionRaw);
        } else {
            curentSesionRaw = null;
            curentSesion = null;
        }
    }
    function editInfo() {}
    function editProbe() {}
    function userSelectSession() {
        selectSession(sessionUserSelection);
    }
    function newSesion() {
        /* const newSessoin = JSON.parse(JSON.stringify(exampleSessoinDEV)); // deep copy
        newSessoin.id = newSessoin.id + 1;
        avalibleSesions.push(newSessoin);
        avalibleSesions = avalibleSesions; // update event TO DO PROXY */
        newSesionInProgres = true;
    }
    function submitNewSession(data) {
        newSesionInProgres = false;
    }
    /* function submitNewSession(data) {
        if (data) {
            console.log("Submited data", data.detail.text);
            const pld = data.detail.text;
            NewBatch.set({
                id: getNextBatchId().toString(),
                val: pld,
            });
        }
        newSesionInProgres = false;
    } */
    function destructor() {
    }
    onDestroy(destructor);
</script>

<div class="rootSpace">
    <h1 class="columTitle">
        <span class="material-icons"> event_note </span>
        <span>Administrativa zakázek</span>
    </h1>
    <div class="standartRoot">
        <!-- <div class="selectMesurmnet">
            <div class="standartButton_SMargin">
                <Select
                    bind:userSelected={sessionUserSelection}
                    nullAvalible={true}
                    optionsList={avalibleSesionsDisplayedToSelect}
                />
            </div>

            <div>
                <button
                    disabled={!sessionUserSelection}
                    class="standartButton standartButton_SMargin"
                    on:click={userSelectSession}>Zobrazit</button
                >
                <button
                    disabled={newSesionInProgres}
                    class="standartButton standartButton_SMargin"
                    on:click={newSesion}>Založit</button
                >
            </div>
        </div> -->

        {#if !newSesionInProgres}
            <div style="display: flex; justify-content: center;">
                <!-- <p class="smallTitle">
                Zaznamenání hodnot prostředí
            </p> -->
                <h2 class="commonMainTitle">Možné &nbsp;Akce</h2>
            </div>
            <div
                style="display: flex; justify-content: center;"
                transition:slide={{ delay: 100, duration: 400 }}
            >
                <button
                    class="bigStandartButton"
                    style="min-width: 11rem;"
                    on:click={newSesion}
                >
                    <span class="material-icons-outlined">
                        queue<!-- add_circle_outline -->
                    </span>
                    <span>Přidat</span>
                </button>
                <button
                    class="bigStandartButton"
                    style="min-width: 11rem;"
                    disabled={true}
                >
                    <span class="material-icons-outlined">
                        view_agenda<!-- view_stream --><!-- format_list_bulleted -->
                    </span>
                    <span>Procházet</span>
                </button>
            </div>
        {/if}
        {#if newSesionInProgres}
            <div transition:slide={{ delay: 100, duration: 400 }}>
                <BatchCreator on:submit={submitNewSession} />
            </div>
        {/if}
        {#if !newSesionInProgres && curentSesion}
            <!-- <div>
                <div class="mainTitle">
                    <TitledVal
                        isHeader={true}
                        isUnderline={true}
                        title={"ID"}
                        value={curentSesion.id}
                    />
                </div>

                <div class="chapterBlock">
                    <div class="chapterTitleBox">
                        <h2 class="chapterTitle">Obecné Info</h2>
                        <span class="material-icons" on:click={editInfo}>
                            edit
                        </span>
                    </div>
                    <div class="chpterContent">
                        <div class="contentNode">
                            <TitledVal
                                title={"Vlhkost"}
                                value={curentSesion.session.hum}
                                unit={"%"}
                            />
                        </div>
                        <div class="contentNode">
                            <TitledVal
                                title={"ID etalonu"}
                                value={curentSesion.session.usedControlProbeID}
                            />
                        </div>
                        <div class="contentNode">
                            <TitledVal
                                title={"ID pece"}
                                value={curentSesion.session.usedOvenID}
                            />
                        </div>
                        <div class="contentNode">
                            <TitledVal
                                title={"Obědnáno dne"}
                                value={curentSesion.session.timeOfOrder}
                            />
                        </div>
                    </div>
                </div>
                <div class="chapterBlock">
                    <div class="chapterTitleBox">
                        <h2 class="chapterTitle">Klient Info</h2>
                    </div>
                    <div class="chpterContent">
                        <div class="contentNode">
                            <TitledVal
                                title={"Název"}
                                value={curentSesion.session.clientInfo.name}
                            />
                        </div>
                        <div class="contentNode">
                            <TitledVal
                                title={"ID"}
                                value={curentSesion.session.clientInfo.clientID}
                            />
                        </div>
                        <div class="contentNode">
                            <TitledVal
                                title={"kontaktní email"}
                                value={curentSesion.session.clientInfo
                                    .contatInfo.email}
                            />
                        </div>
                        <div class="contentNode">
                            <TitledVal
                                title={"kontaktní telefon"}
                                value={curentSesion.session.clientInfo
                                    .contatInfo.phone}
                            />
                        </div>
                    </div>
                </div>
                <div class="chapterBlock">
                    <div class="chapterTitleBox">
                        <h2 class="chapterTitle">Testované Teploměry</h2>
                        <span class="material-icons" on:click={editProbe}>
                            edit
                        </span>
                    </div>
                    <div class="chpterContent">
                        {#each curentSesion.session.probeList as probe}
                            <div class="contentNode">
                                <TitledVal
                                    title={probe.label}
                                    value={probe.name}
                                />
                            </div>
                        {/each}
                    </div>
                </div>
                <div class="chapterBlock">
                    <h2 class="chapterTitle">Naměřené hodnoty</h2>
                    {#each curentSesion.session.mesurmentList as merurment}
                        <div class="chpterContent">
                            <div class="contentNode">
                                <TitledVal
                                    title={"Cílová hodnota"}
                                    value={merurment.targetValue}
                                />
                            </div>
                            <div class="contentNode">
                                <TitledVal
                                    title={"Kontrolní hodnota"}
                                    value={merurment.controlValue}
                                />
                            </div>
                            <div class="contentNode">
                                <TitledVal
                                    title={"Čas měření"}
                                    value={merurment.timestamp}
                                />
                            </div>

                            <div class="chpterContent">
                                {#each merurment.valList as val}
                                    <div class="contentNode">
                                        <TitledVal
                                            title={val.label}
                                            value={val.value}
                                            unit={"°C"}
                                        />
                                    </div>
                                {/each}
                            </div>
                        </div>
                    {/each}
                </div>
            </div> -->
        {/if}
    </div>
</div>

<style>
    .mainTitle {
        border: solid 2px var(--back_D12);
        border-left: none;
        border-right: none;
        padding: 0.5rem;
        /* background: #fbfbfb; */
        background: #f7f7f7;
    }
    .chapterBlock {
        margin: 1rem 0.8rem;
        border: solid 2px var(--back_D12);
        border-left: none;
        border-right: none;
        padding: 0.5rem;
        /* background: #fbfbfb; */
        background: #f7f7f7;
    }
    .chapterTitleBox {
        display: flex;
        align-items: center;
    }
    .chapterTitle {
        font-weight: 300;
        font-size: 1.3rem;
        color: var(--back_D2);
        margin: 0.2em 0;
    }
    .chapterTitleBox > .material-icons {
        padding: 7px;
        border-radius: 50%;
        margin-left: 10px;
        color: var(--back_D2);
        /* background: #f5f5f5; */
    }
    .chapterTitleBox > .material-icons:hover {
        background: #ccc;
        color: black;
    }
    .chpterContent {
        margin: 15px 5px;
        padding: 0.5rem;
        border-left: solid 3px var(--prim);
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        box-sizing: border-box;
    }
    .chpterContent .chpterContent {
        border-left: solid 2px var(--prim);
        margin-left: 1rem;
    }
    .contentNode {
        margin: 0.5rem 2rem 0.5rem 0.5rem;
    }
    /* .contentNode:first-of-type {
        margin-left: 1rem;
    } */
</style>
